import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Section, CollectionItem, ContentElement, GridCell, OrientationEnum, RowCell, RowOptions, SectionData } from '../../models/sections-model';
import { CollectionsService } from '../../data/services/collections.service';

@Component({
  selector: 'kw-row-renderer',
  templateUrl: './row-renderer.component.html',
  styleUrls: ['./row-renderer.component.scss']
})
export class RowRendererComponent implements OnInit,OnChanges {
  @Input() data:SectionData;
  @Input() edit:boolean;
  rowOptions:RowOptions;
  title:ContentElement;
  wine:CollectionItem[];
  plantItems:CollectionItem[];
  collectionItems:CollectionItem[];
  widewine:CollectionItem[];
  wellnessItems:CollectionItem[];
  preserves:CollectionItem[];
  food:CollectionItem[];
  numberOfElements:number;
  rowCells:any;
  fullWidth:boolean;
  preview:boolean;
  cellId:string;
  selectedCell:GridCell | RowCell

  layoutClass:string;
  wrapperClass:string;

  layoutClassList = [
    "cell-layout-default",
    "cell-layout-classic-card",
    "cell-layout-split-top-bottom",
    "cell-layout-all-top-halfed",
    "cell-layout-all-bottom-halfed",
    "cell-layout-fit-both"
  ]

  row1:RowOptions = {
    numberOfElements:3,
    rowCells:[
      {
        cellId:"001",
        imageOrientation:OrientationEnum.LANDSCAPE,
        imgSrc:"https://placehold.co/406x240?text",
        altImgSrc:"https://placehold.co/406x240/orange/white",
        width:406,
        height:240
      },
      {
        cellId:"002",
        imageOrientation:OrientationEnum.LANDSCAPE,
        imgSrc:"https://placehold.co/406x240?text",
        altImgSrc:"https://placehold.co/406x240/orange/white",
        width:406,
        height:240
      },
      {
        cellId:"003",
        imageOrientation:OrientationEnum.LANDSCAPE,
        imgSrc:"https://placehold.co/406x240?text",
        altImgSrc:"https://placehold.co/406x240/orange/white",
        width:406,
        height:240
      }
    ]
  }
  row2:RowOptions = {
    numberOfElements:4,
    rowCells:[
      {
        cellId:"001",
        imgSrc:"https://placehold.co/305x171?text",
        altImgSrc:"https://placehold.co/305x171/orange/white"
      },
      {
        cellId:"002",
        imgSrc:"https://placehold.co/305x171?text",
        altImgSrc:"https://placehold.co/305x171/orange/white"
      },
      {
        cellId:"003",
        imgSrc:"https://placehold.co/305x171?text",
        altImgSrc:"https://placehold.co/305x171/orange/white"
      },
      {
        cellId:"004",
        imgSrc:"https://placehold.co/305x171?text",
        altImgSrc:"https://placehold.co/305x171/orange/white"
      }
    ]
  }
  row3:RowOptions = {
    numberOfElements:6,
    rowCells:[
      {
        cellId:"001",
        imgSrc:"https://placehold.co/196x245?text",
        altImgSrc:"https://placehold.co/196x245/orange/white"
      },
      {
        cellId:"002",
        imgSrc:"https://placehold.co/196x245?text",
        altImgSrc:"https://placehold.co/196x245/orange/white"
      },
      {
        cellId:"003",
        imgSrc:"https://placehold.co/196x245?text",
        altImgSrc:"https://placehold.co/196x245/orange/white"
      },
      {
        cellId:"004",
        imgSrc:"https://placehold.co/196x245?text",
        altImgSrc:"https://placehold.co/196x245/orange/white"
      },
      {
        cellId:"005",
        imgSrc:"https://placehold.co/196x245?text",
        altImgSrc:"https://placehold.co/196x245/orange/white"
      },
      {
        cellId:"006",
        imgSrc:"https://placehold.co/196x245?text",
        altImgSrc:"https://placehold.co/196x245/orange/white"
      }
    ]
  }
  row4:RowOptions = {
    numberOfElements:8,
    rowCells:[
      {
        imgSrc:""
      },
      {
        imgSrc:""
      },
      {
        imgSrc:""
      },
      {
        imgSrc:""
      },{
        imgSrc:""
      },
      {
        imgSrc:""
      },
      {
        imgSrc:""
      },
      {
        imgSrc:""
      }
    ]
  }


    rowSectionData:any[] = []

  @Output() editUpdate = new EventEmitter<any>();
  @Output() createUpdate = new EventEmitter<RowCell>();
  
  constructor(private cdr: ChangeDetectorRef) { }
  
  ngOnChanges(changes: SimpleChanges): void {

  }

  ngOnInit(): void {
    console.log(this.data);
    this.title = this.data.title;
    this.wrapperClass = this.data.wrapperClass?this.data.wrapperClass:"solid";
    this.numberOfElements = this.data.numberOfElements;
    this.rowOptions = this.data.rowOptions;
    this.layoutClass = this.data.layoutClass;
    if(this.layoutClass == "ProductRowLayoutEnum.THREE_COL_PORTRIAT"){
      this.layoutClass="col-3-portrait";
    }
    if(this.layoutClass == "ProductRowLayoutEnum.FOUR_COL_PORTRIAT"){
      this.layoutClass="col-4-portrait";
    }
    if(this.layoutClass == "ProductRowLayoutEnum.FIVE_COL_PORTRIAT"){
      this.layoutClass="col-5-portrait";
    }
    if(this.layoutClass == "ProductRowLayoutEnum.SIX_COL_PORTRIAT"){
      this.layoutClass="col-6-portrait";
    }
    this.rowCells = this.data.rowOptions.rowCells;
    console.log(this.rowCells)
    this.preview = this.data.isPreview?this.data.isPreview:false;
    console.log(this.preview);
    this.selectedCell = this.data.selectedCell?this.data.selectedCell:null;

    /* this.collectionsService.getCollectionItems().subscribe(collectionItems => {
      this.plantItems = collectionItems.filter((collectionItem) =>collectionItem.imageWithText.text == "Plants");
      this.collectionItems = collectionItems.filter((collectionItem) =>collectionItem.imageWithText.text == "Succulents");
      this.widewine = collectionItems.filter((collectionItem) =>collectionItem.imageWithText.text == "Widewine");
      this.wine = collectionItems.filter((collectionItem) =>collectionItem.imageWithText.text == "Wine");
      this.wellnessItems = collectionItems.filter((collectionItem) =>collectionItem.imageWithText.text == "Wellness");
      this.preserves = collectionItems.filter((collectionItem) =>collectionItem.imageWithText.text == "Preserves");
      this.food = collectionItems.filter((collectionItem) =>collectionItem.imageWithText.text == "Food");
      this.createRowSectionData();
    }) */
    //this.rowCells = this.data.rowCells;
    //console.log(this.data)
  }

  createRowSectionData(){
    if(this.widewine != undefined){
      /* for(let i=0;i < this.row1.rowCells.length;i++){
        this.row1.rowCells[i].imgSrc = this.widewine[i].imageWithText.src;
        this.row1.rowCells[i].altImgSrc = this.wine[i].imageWithText.src;
      } */
      let data = {
        rendererType:'row',
        heading:'Row 1',
        rowOptions:this.row1
      }
      this.rowSectionData.push(data);
      //console.log(this.rowSectionData)
    }
    if(this.plantItems != undefined){
     /*  for(let i=0;i < this.row2.rowCells.length;i++){
        this.row2.rowCells[i].imgSrc = this.plantItems[i].imageWithText.src
        this.row2.rowCells[i].altImgSrc = this.collectionItems[i+4].imageWithText.src
      } */
      let data = {
        rendererType:'row',
        heading:'Row 2',
        rowOptions:this.row2
      }
      this.rowSectionData.push(data);
    }
    if(this.preserves != undefined){
      /* for(let i=0;i < this.row3.rowCells.length;i++){
        this.row3.rowCells[i].imgSrc = this.preserves[i].imageWithText.src;
        this.row3.rowCells[i].altImgSrc = this.food[i].imageWithText.src;
      } */
      let data = {
        rendererType:'row',
        heading:'Row 3',
        rowOptions:this.row3
      }
      this.rowSectionData.push(data);
    }
    if(this.wellnessItems != undefined){
      for(let i=0;i < this.row4.rowCells.length;i++){
        this.row4.rowCells[i].imgSrc = this.wellnessItems[i].imageWithText.src
      }
      let data = {
        rendererType:'row',
        heading:'Row 4',
        rowOptions:this.row4
      }
      this.rowSectionData.push(data);
    }
    //console.log(this.rowSectionData);
  }

  setRowCells(numberOfElements:number){
    if(numberOfElements > 4){
      if(this.rowSectionData.length > 0){
        for(let i = 0;i < this.rowSectionData.length;i++){
          if(this.rowSectionData[i].rowOptions.numberOfElements == numberOfElements){
            this.rowCells = this.rowSectionData[i].rowOptions.rowCells;
            break
          }
        }
      }
      //console.log(this.rowCells)
    }
    
  }

  createContent(cell:GridCell|RowCell){
    console.log(cell)
    this.createUpdate.emit(cell);
  }
  updateSection(section:Section){
    console.log(section);
    this.data = section;
    this.rowCells = section.sectionData.rowOptions.rowCells;
    console.log(this.rowCells);
    this.cdr.detectChanges();
  }

}
